export function mediaElementReadyStateToString(
  element?: HTMLMediaElement,
): undefined | 'have_nothing' | 'have_metadata' | 'have_current_data' | 'have_future_data' | 'have_enough_data' {
  const states = [
    'have_nothing',
    'have_metadata',
    'have_current_data',
    'have_future_data',
    'have_enough_data',
  ] as const;
  return states[element?.readyState];
}
